import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import seriousRiskByYear from './serious-risk-by-year.component';
import seriousRiskByYearService from './serious-risk-by-year.service';

export default
  angular.module('components.reports.seriousRiskByYear', [
    uiRouter
  ])
    .component('seriousRiskByYear', seriousRiskByYear)
    .service('SeriousRiskByYearService', seriousRiskByYearService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('seriousRiskByYear', {
          parent: 'reports',
          url: '/serious-risk-by-year',
          component: 'seriousRiskByYear',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/serious-risk-by-year/serious-risk-by-year.module.js